import React, { useState } from 'react'
import { motion } from 'framer-motion';
import Logo from '../../assets/image/Logo.png'
import Waves from '../../assets/image/wave.png'
import axios from 'axios';
import { API } from '../../shared/api/Api';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Live/Loader';
import Toast from '../../components/Sweetalert/Sweetalert';
import ShowPasswordIcon from '../../assets/svg/ShowPassword.svg';
import HidePasswordIcon from '../../assets/svg/HidePassword.svg';
import { showToast } from '../../utils/utils';

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.1,
            delayChildren: 0.2
        }
    }
};

const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
    hover: { scale: 1.05 },
    tap: { scale: 0.95 }
};

const waveVariants = {
    animate: {
        y: ["0%", "-5%", "0%"],
        transition: {
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut"
        }
    }
};

const ForgetPassword = () => {
    const [email, setEmail] = useState('');
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();

    const handleVerifyEmail = async () => {
        try {
            setLoader(true)
            const { data } = await axios.post(API.Admin.forgetPassword,
                {
                    email_or_phone: email
                },
                {
                    headers: {
                        lang: 'en'
                    }
                }
            );

            if (data.status === 200 && data.errorCode === 0) {
                setLoader(false)
                showToast('Email Verified Successfully', data.message, 'success')
                navigate('/password/reset', { state: { email: email } });
            } else {
                showToast('Oops, Something went wrong', data.message, 'error')
            }
        } catch (error) {
            console.log(error)
            setLoader(false)
            if (error.response.status === 400) {
                showToast('Oops, Something went wrong', error.response.data.data.email_or_phone, 'error')
            } else if (error.response.status === 404) {
                showToast('Oops, Something went wrong', error.response.data.message, 'error')
            } else {
                showToast('Oops, Something went wrong', 'There is an error, please try again later', 'error')
            }
        }

    }

    if (loader) {
        return (
            <div className='mt-[30%] sl:mt-[20%] ll:mt-[15%]'>
                <Loader />
            </div>
        )
    }

    return (
        <motion.div
            initial="hidden"
            animate="visible"
            variants={containerVariants}
            className='flex flex-1 justify-center items-center mx-auto w-full h-screen p-4 md:p-6 sl:p-8'
        >
            <div className='flex flex-col justify-center items-center mx-auto space-y-4 md:space-y-6 sl:space-y-8 ll:space-y-10'>
                <motion.img
                    variants={itemVariants}
                    className='w-24 h-24 md:w-28 md:h-28 sl:w-32 sl:h-32 ll:w-36 ll:h-36'
                    src={Logo}
                    alt='logo'
                />

                <motion.h1
                    variants={itemVariants}
                    className='text-3xl md:text-4xl sl:text-5xl ll:text-6xl font-medium text-primary text-center'
                >
                    Did You Forget Your Password
                </motion.h1>

                <motion.span
                    variants={itemVariants}
                    className='text-lg md:text-xl sl:text-2xl ll:text-3xl font-medium text-primary text-center'
                >
                    Don't worry you can reset it !!
                </motion.span>

                <motion.div
                    variants={itemVariants}
                    className='flex flex-col justify-center items-center mx-auto space-y-6 md:space-y-8 sl:space-y-10 w-full max-w-xs md:max-w-sm sl:max-w-md ll:max-w-lg'
                >
                    <motion.input
                        variants={itemVariants}
                        type="text"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter Your Email"
                        className="w-full h-input md:h-input-md sl:h-input-lg px-4 md:px-6 sl:px-8 bg-accent rounded-lg focus:outline-none focus:ring-2 focus:ring-primary text-base md:text-lg sl:text-xl ll:text-2xl placeholder:text-secondary/70"
                        whileFocus={{ scale: 1.02 }}
                    />

                    <motion.button
                        variants={itemVariants}
                        type="button"
                        onClick={handleVerifyEmail}
                        className="w-full h-input md:h-input-md sl:h-input-lg border-2 border-primary text-primary md:text-lg sl:text-xl ll:text-2xl rounded-lg hover:bg-primary hover:text-white transition-colors font-medium"
                        whileHover="hover"
                        whileTap="tap"
                    >
                        Send
                    </motion.button>
                </motion.div>
            </div>

            <motion.div
                className="absolute bottom-0 left-0 right-0 w-full"
                variants={waveVariants}
                animate="animate"
            >
                <img
                    src={Waves}
                    alt='waves'
                    className="w-full h-auto max-h-20 md:max-h-24 sl:max-h-28 ll:max-h-32"
                />
            </motion.div>
        </motion.div>
    );
    // return (
    //     <div className='flex flex-1 justify-center items-center mx-auto w-full h-screen'>
    //         {/* Logo */}
    //         <div className='flex flex-col justify-center items-center mx-auto space-y-8'>
    //             <img className='w-[149px] h-[149px]' src={Logo} alt='logo' />

    //             <h1 className='text-[40px] font-[500] text-[#134F98]'> Did You Forget Your Password </h1>
    //             <span className='text-[20px] font-[500] text-[#134F98]'> Don't worry you can reset it !! </span>
    //             <div className='flex flex-col justify-center items-center mx-auto space-y-12 w-[493px]'>
    //                 <input
    //                     type="text"
    //                     name="password"
    //                     value={email}
    //                     onChange={(e) => setEmail(e.target.value)}
    //                     placeholder="Enter Your Email"
    //                     className="input-field h-[70px] bg-[#F3F3F3] w-full"
    //                 />
    //                 <button
    //                     type="button"
    //                     onClick={handleVerifyEmail}
    //                     className="border-2 border-[#134F98] text-[#134F98] text-[24px] py-2 px-4 rounded-lg w-full h-[69px] hover:bg-[#134F98] hover:text-white transition"
    //                 >
    //                     Send
    //                 </button>
    //             </div>
    //         </div>

    //         {/* Waves */}
    //         <div className='absolute bottom-0'>
    //             <img src={Waves} alt='waves' />
    //         </div>
    //     </div>
    // )
}

export default ForgetPassword
